<template>
    <input
      ref="inputRef"
      v-bind="$attrs"
      :id="id"
      :name="name"
      :placeholder="placeholder"
      class="form-control"
      tabindex="-1"
    />
  </template>
  
  <script lang="ts">
  import { Component, Vue, toNative, Prop, Ref, Watch } from 'vue-facing-decorator'
  import { useCurrencyInput } from 'vue-currency-input'
  
  @Component({
    emits: ['update:modelValue', 'blur', 'change']
  })
  class Money extends Vue {
    @Prop({ type: [String,Number]}) readonly modelValue!: string|number
    @Prop({ type: Object }) readonly options!: object
  
    @Prop({ type: String }) readonly id?: string
    @Prop({ type: String }) readonly name?: string
    @Prop({ type: String }) readonly placeholder?: string
  
    @Ref('inputRef') readonly inputRef!: HTMLInputElement
  
    private setValue!: (value: number) => void
    private setOptions!: (options: object) => void
  
    mounted() {
      const { inputRef, setValue, setOptions, numberValue } = useCurrencyInput(this.options)
  
      inputRef.value = this.inputRef
      this.setValue = setValue
      this.setOptions = setOptions
  
      if (this.modelValue != null) {
        this.setValue(this.modelValue)
      }
  
      // Emit model updates
      this.inputRef.addEventListener('input', () => {
        if (numberValue.value != null) {
          // always return float with 2 decimals
          this.$emit('update:modelValue', parseFloat(numberValue.value.toFixed(2)))
        } else {
          this.$emit('update:modelValue', null)
        }

      })
    }
  
    @Watch('modelValue')
onModelValueChanged(value: number) {
  if (this.setValue && value != null) {
    // force 2 decimals before updating the input
    this.setValue(Number(value.toFixed(2)))
  }
}

  
    @Watch('options', { deep: true })
    onOptionsChanged(options: object) {
      if (this.setOptions) {
        this.setOptions(options)
      }
    }
  }
  
  export default toNative(Money)
  </script>
  